// extracted by mini-css-extract-plugin
module.exports = {"notFound_wrapper":"notFound_notFound_wrapper__3OlIB"};